import { FieldLabel } from '@measured/puck';
import React, { useState } from 'react';
import CustomTooltip from '../../../components/common/tooltip';
import { MarginType } from '../../puck/reusable-props/margin';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import InputField from '../../../components/common/input-field';
import { getNumberPattern } from '../../utils/helper';

interface marginComponenrProps {
  value: MarginType;
  onChange: (_value: MarginType) => void;
  title?: string;
  extraFields?: boolean;
}

const MarginComponent: React.FC<marginComponenrProps> = ({
  value,
  onChange,
  title = 'Customize Margin',
  extraFields = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = (platform: string, key: string, option: string) => {
    onChange({
      ...value,
      [platform]: {
        ...value[platform as keyof MarginType],
        [key]: option,
      },
    });
  };

  return (
    <div>
      <div
        className=" flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={toggleAccordion}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  items-center border  border-gray-300 rounded  p-2 w-full ">
          <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
            <FieldLabel
              label={
                (
                  <CustomTooltip title="desktopMargin">
                    <span>Desktop</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }>
              <div className="grid grid-cols-[1fr_1fr] gap-2 border-t-1">
                {' '}
                <InputField
                  value={value.desktop.top}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('desktop', 'top', value || '');
                  }}
                  onBlur={() => {
                    if (!value.desktop.top || value.desktop.top === '-') {
                      handleChange('desktop', 'top', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Top"
                />
                <InputField
                  value={value.desktop.bottom}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('desktop', 'bottom', value || '');
                  }}
                  onBlur={() => {
                    if (!value.desktop.bottom || value.desktop.bottom === '-') {
                      handleChange('desktop', 'bottom', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Bottom"
                />
                <InputField
                  value={value?.desktop?.left}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('desktop', 'left', value || '');
                  }}
                  onBlur={() => {
                    if (!value.desktop.left || value.desktop.left === '-') {
                      handleChange('desktop', 'left', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Left"
                />
                <InputField
                  value={value.desktop.right}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('desktop', 'right', value || '');
                  }}
                  onBlur={() => {
                    if (!value.desktop.right || value.desktop.right === '-') {
                      handleChange('desktop', 'right', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Right"
                />
              </div>
            </FieldLabel>
          </div>
          <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
            <FieldLabel
              label={
                (
                  <CustomTooltip title="tabletMargin">
                    <span>Tablet</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }>
              <div className="grid grid-cols-[1fr_1fr] gap-2 ">
                <InputField
                  value={value.tablet.top}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('tablet', 'top', value || '');
                  }}
                  onBlur={() => {
                    if (!value.tablet.top || value.tablet.top === '-') {
                      handleChange('tablet', 'top', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Top"
                />
                <InputField
                  value={value.tablet.bottom}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('tablet', 'bottom', value || '');
                  }}
                  onBlur={() => {
                    if (!value.tablet.bottom || value.tablet.bottom === '-') {
                      handleChange('tablet', 'bottom', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Bottom"
                />
                <InputField
                  value={value.tablet.left}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('tablet', 'left', value || '');
                  }}
                  onBlur={() => {
                    if (!value.tablet.left || value.tablet.left === '-') {
                      handleChange('tablet', 'left', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Left"
                />
                <InputField
                  value={value.tablet.right}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('tablet', 'right', value || '');
                  }}
                  onBlur={() => {
                    if (!value.tablet.right || value.tablet.right === '-') {
                      handleChange('tablet', 'right', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Right"
                />
              </div>
            </FieldLabel>
          </div>
          <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
            <FieldLabel
              label={
                (
                  <CustomTooltip title="mobileMargin">
                    <span>Mobile</span>
                  </CustomTooltip>
                ) as React.ReactNode as string
              }>
              <div className="grid grid-cols-[1fr_1fr] gap-2">
                <InputField
                  value={value.mobile.top}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('mobile', 'top', value || '');
                  }}
                  onBlur={() => {
                    if (!value.mobile.top || value.mobile.top === '-') {
                      handleChange('mobile', 'top', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Top"
                />
                <InputField
                  value={value.mobile.bottom}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('mobile', 'bottom', value || '');
                  }}
                  onBlur={() => {
                    if (!value.mobile.bottom || value.mobile.bottom === '-') {
                      handleChange('mobile', 'bottom', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Bottom"
                />
                <InputField
                  value={value.mobile.left}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('mobile', 'left', value || '');
                  }}
                  onBlur={() => {
                    if (!value.mobile.left || value.mobile.left === '-') {
                      handleChange('mobile', 'left', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Left"
                />
                <InputField
                  value={value.mobile.right}
                  onChange={e => {
                    const value = getNumberPattern(e, true);
                    handleChange('mobile', 'right', value || '');
                  }}
                  onBlur={() => {
                    if (!value.mobile.right || value.mobile.right === '-') {
                      handleChange('mobile', 'right', '0');
                    }
                  }}
                  className="h-[42px]"
                  label="Right"
                />
              </div>
            </FieldLabel>
          </div>
          {extraFields && (
            <>
              <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="2xlMargin">
                        <span>XL</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <div className="grid grid-cols-[1fr_1fr] gap-2">
                    <InputField
                      value={value?.doubleXL?.top}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('doubleXL', 'top', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.doubleXL?.top ||
                          value?.doubleXL?.top === '-'
                        ) {
                          handleChange('doubleXL', 'top', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Top"
                    />
                    <InputField
                      value={value?.doubleXL?.bottom}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('doubleXL', 'bottom', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.doubleXL?.bottom ||
                          value?.doubleXL?.bottom === '-'
                        ) {
                          handleChange('doubleXL', 'bottom', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Bottom"
                    />
                    <InputField
                      value={value?.doubleXL?.left}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('doubleXL', 'left', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.doubleXL?.left ||
                          value?.doubleXL?.left === '-'
                        ) {
                          handleChange('doubleXL', 'left', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Left"
                    />
                    <InputField
                      value={value?.doubleXL?.right}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('doubleXL', 'right', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.doubleXL?.right ||
                          value?.doubleXL?.right === '-'
                        ) {
                          handleChange('doubleXL', 'right', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Right"
                    />
                  </div>
                </FieldLabel>
              </div>
              <div className="border border-gray-300 rounded p-2 w-full pagebuilder-theme">
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="3xlMargin">
                        <span>2XL</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <div className="grid grid-cols-[1fr_1fr] gap-2">
                    <InputField
                      value={value?.tripleXL?.top}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('tripleXL', 'top', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.tripleXL?.top ||
                          value?.tripleXL?.top === '-'
                        ) {
                          handleChange('tripleXL', 'top', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Top"
                    />
                    <InputField
                      value={value?.tripleXL?.bottom}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('tripleXL', 'bottom', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.tripleXL?.bottom ||
                          value?.tripleXL?.bottom === '-'
                        ) {
                          handleChange('tripleXL', 'bottom', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Bottom"
                    />
                    <InputField
                      value={value?.tripleXL?.left}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('tripleXL', 'left', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.tripleXL?.left ||
                          value?.tripleXL?.left === '-'
                        ) {
                          handleChange('tripleXL', 'left', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Left"
                    />
                    <InputField
                      value={value?.tripleXL?.right}
                      onChange={e => {
                        const value = getNumberPattern(e, true);
                        handleChange('tripleXL', 'right', value || '');
                      }}
                      onBlur={() => {
                        if (
                          !value?.tripleXL?.right ||
                          value?.tripleXL?.right === '-'
                        ) {
                          handleChange('tripleXL', 'right', '0');
                        }
                      }}
                      className="h-[42px]"
                      label="Right"
                    />
                  </div>
                </FieldLabel>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MarginComponent;
